// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.StormWaterTrueQIForecast {
  color: #fff;
  background-color: #050e25;
  height: 90vh;
  width: 100%;
  margin: 0px;
  padding: 0px;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 10px; }
  .StormWaterTrueQIForecast .expand-container {
    position: absolute;
    top: 65px;
    left: 70px;
    height: 90vh !important;
    width: 91%;
    z-index: 100; }
  .StormWaterTrueQIForecast .mapboxgl-popup-content {
    min-width: 405px;
    padding: 0px !important;
    opacity: .95;
    border-radius: 4px;
    width: 100% !important;
    background-color: #18244c; }
  .StormWaterTrueQIForecast .mapboxgl-popup-anchor-top .mapboxgl-popup-tip {
    border-bottom-color: #18244c;
    opacity: .8; }
  .StormWaterTrueQIForecast .mapboxgl-popup-close-button {
    display: none; }
  .StormWaterTrueQIForecast .popup-container {
    padding-top: 7px;
    padding-bottom: 32px;
    padding-left: 10px;
    padding-right: 4px;
    font-size: 14px;
    min-width: 405px;
    background-color: #050E25;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: max-content;
    font-weight: 500;
    opacity: .95;
    text-align: center;
    height: 115px;
    line-height: 10px;
    font-family: "Urbanist";
    display: flex;
    flex-direction: column;
    width: max-content; }
  .StormWaterTrueQIForecast .popup-content {
    display: flex;
    flex-direction: row;
    justify-content: flex-start; }
  .StormWaterTrueQIForecast .popup-content-left {
    text-align: right;
    margin-right: 10px;
    min-width: 80px;
    max-width: min-content;
    line-height: 14px;
    word-wrap: break-word; }
  .StormWaterTrueQIForecast .popup-content-left p {
    text-align: right;
    word-wrap: break-word; }
  .StormWaterTrueQIForecast .popup-content-right {
    text-align: left;
    max-width: 250px;
    line-height: 14px;
    font-size: 18px; }
  .StormWaterTrueQIForecast .popup-content-right-double {
    height: 28px; }
  .StormWaterTrueQIForecast .popup-content-highlight {
    color: #49b4cd; }
  .StormWaterTrueQIForecast .container {
    display: flex;
    padding: 0;
    height: 90%;
    margin-top: 10px;
    max-width: inherit; }
    .StormWaterTrueQIForecast .container input,
    .StormWaterTrueQIForecast .container select {
      margin-bottom: 50px; }
    .StormWaterTrueQIForecast .container .map-title {
      width: auto;
      white-space: nowrap;
      position: absolute;
      left: 59px;
      top: 0px;
      font-size: 1.25rem;
      padding: 5px;
      z-index: 9; }
    .StormWaterTrueQIForecast .container .map-best-container {
      background-color: #0b1736;
      border-radius: 2px;
      box-shadow: 0px 0px 20px #000;
      display: flex;
      position: relative;
      height: 50vh;
      padding: 0px !important; }
    .StormWaterTrueQIForecast .container .map-legend {
      width: 259px;
      position: absolute;
      border-radius: 5px;
      padding: 5px;
      right: 40px;
      bottom: 10px;
      background-color: #18244c;
      z-index: 90;
      height: 170px; }
    .StormWaterTrueQIForecast .container .map-legend p {
      margin-left: 5px;
      margin-bottom: 24px;
      height: 35px; }
    .StormWaterTrueQIForecast .container .map-legend span {
      width: 100px;
      margin-left: 5px; }
    .StormWaterTrueQIForecast .container .map-legend-dot {
      background-color: #4b5ea6;
      height: 14px;
      width: 14px;
      margin-left: 5px;
      margin-right: 5px;
      border-radius: 50%;
      display: inline-flex; }
    .StormWaterTrueQIForecast .container .attribution-textbox {
      font-size: .6rem;
      position: absolute;
      right: 1px;
      bottom: 0px;
      width: auto; }
    .StormWaterTrueQIForecast .container .expand-container-summary {
      position: absolute;
      top: 59px;
      left: 50px;
      height: 90vh !important;
      width: 95% !important;
      z-index: 100;
      padding-top: 45px !important;
      overflow: scroll !important;
      flex-flow: wrap; }
    .StormWaterTrueQIForecast .container .expand-summary-button {
      display: unset;
      position: absolute;
      top: 1px;
      left: 0px;
      z-index: 1001; }
    .StormWaterTrueQIForecast .container .summary-container {
      background-color: #0b1736;
      border-radius: 2px;
      box-shadow: 0px 0px 20px #000;
      display: flex;
      margin-top: 12px;
      margin-left: 10px;
      padding-top: 0px;
      height: 33vh;
      width: 300px;
      overflow-x: hidden;
      overflow-y: scroll;
      flex-direction: column; }
    .StormWaterTrueQIForecast .container .summary-header {
      flex-wrap: nowrap;
      width: 220px; }
    .StormWaterTrueQIForecast .container .card {
      padding-left: 2px;
      width: 250px;
      line-height: 18px;
      margin-bottom: 10px;
      max-width: 250px; }
    .StormWaterTrueQIForecast .container .card-header {
      height: 37px; }
    .StormWaterTrueQIForecast .container .card-title p {
      margin-bottom: .1rem; }
    .StormWaterTrueQIForecast .container .card-title hr {
      margin: 0.1rem;
      opacity: .1; }
    .StormWaterTrueQIForecast .container .summary-card-label {
      font-size: .8rem;
      color: #838487;
      padding-bottom: .1rem; }
    .StormWaterTrueQIForecast .container .summary-card-label-hr {
      opacity: .5 !important;
      padding: 0.1rem !important; }
    .StormWaterTrueQIForecast .container .summary-card-span-label {
      font-size: 1rem;
      color: #838487;
      padding-bottom: .1rem; }
    .StormWaterTrueQIForecast .container .summary-container-span {
      font-size: 1.2rem; }
    .StormWaterTrueQIForecast .container .summary-button {
      width: 44px;
      display: inline-flex;
      align-self: flex-end;
      background-color: white; }
    .StormWaterTrueQIForecast .container .summary-top {
      width: 100px; }
    .StormWaterTrueQIForecast .container .te-primary {
      background-color: #021d3e; }
    .StormWaterTrueQIForecast .container .te-secondary {
      background-color: #050e25; }
    .StormWaterTrueQIForecast .container .chart-container {
      background-color: #0b1736;
      border-radius: 2px;
      box-shadow: 0px 0px 20px #000;
      display: flex;
      margin-top: 10px;
      margin-left: 12px;
      height: 33vh;
      width: calc(100% - 332px); }
    .StormWaterTrueQIForecast .container .chart-line-container {
      height: 100%;
      width: 100%;
      width: -webkit-fill-available;
      width: -moz-available;
      width: stretch; }
    .StormWaterTrueQIForecast .container .report-options {
      margin-top: 20px;
      text-align: right;
      margin-right: 10px; }
      .StormWaterTrueQIForecast .container .report-options button {
        background-color: #fff;
        border: unset;
        margin-left: 10px; }

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .StormWaterTrueQIForecast .header-container h2 {
    font-size: 20px; } }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/features/reports/StormWaterTrueQIForecast/styles.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;ACdrD;EACE,WDVqB;ECWrB,yBDEsC;ECDtC,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EAEZ,kBAfoB;EAgBpB,mBAhBoB;EAiBpB,iBAhBmB,EAAA;EAMrB;IAaI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,UAAU;IACV,YAAY,EAAA;EAlBhB;IAsBI,gBAAgB;IAChB,uBAAuB;IAEvB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB,EAAA;EA5B7B;IAgCI,4BAA4B;IAC5B,WAAW,EAAA;EAjCf;IAqCI,aAAa,EAAA;EArCjB;IAyCI,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,kBAAkB,EAAA;EA5DtB;IAgEI,aAAa;IACb,mBAAmB;IACnB,2BAA2B,EAAA;EAlE/B;IAuEI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,qBAAqB,EAAA;EA5EzB;IAgFI,iBAAiB;IACjB,qBAAqB,EAAA;EAjFzB;IAsFI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe,EAAA;EAzFnB;IA6FI,YAAY,EAAA;EA7FhB;IAiGI,cAAc,EAAA;EAjGlB;IAqGI,aAAa;IACb,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,kBAAkB,EAAA;IAzGtB;;MA6GM,mBAAmB,EAAA;IA7GzB;MAiHM,WAAW;MACX,mBAAmB;MACnB,kBAAkB;MAClB,UAAU;MACV,QAAQ;MACR,kBAAkB;MAClB,YAAY;MACZ,UAAU,EAAA;IAxHhB;MA4HM,yBDlI0B;MCmI1B,kBAAkB;MAClB,6BAA6B;MAC7B,aAAa;MACb,kBAAkB;MAClB,YAAY;MACZ,uBAAuB,EAAA;IAlI7B;MAsIM,YAAY;MACZ,kBAAkB;MAClB,kBAAkB;MAClB,YAAY;MACZ,WAAW;MACX,YAAY;MACZ,yBAAyB;MACzB,WAAW;MACX,aAAa,EAAA;IA9InB;MAkJM,gBAAgB;MAChB,mBAAmB;MACnB,YAAY,EAAA;IApJlB;MAwJM,YAAY;MACZ,gBAAgB,EAAA;IAzJtB;MA6JM,yBAAyB;MACzB,YAAY;MACZ,WAAW;MACX,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB;MAClB,oBAAoB,EAAA;IAnK1B;MAuKM,gBAAgB;MAChB,kBAAkB;MAClB,UAAU;MACV,WAAW;MACX,WAAW,EAAA;IA3KjB;MA+KM,kBAAkB;MAClB,SAAS;MACT,UAAU;MACV,uBAAuB;MACvB,qBAAqB;MACrB,YAAY;MACZ,4BAA4B;MAC5B,2BAA2B;MAC3B,eAAe,EAAA;IAvLrB;MA2LM,cAAc;MACd,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,aAAa,EAAA;IA/LnB;MAmMM,yBDzM0B;MC0M1B,kBAAkB;MAClB,6BAA6B;MAC7B,aAAa;MACb,gBAAgB;MAChB,iBAAiB;MACjB,gBAAgB;MAChB,YAAY;MACZ,YAAY;MACZ,kBAAkB;MAClB,kBAAkB;MAClB,sBAAsB,EAAA;IA9M5B;MAkNM,iBAAiB;MACjB,YAAY,EAAA;IAnNlB;MAuNM,iBAAiB;MACjB,YAAY;MACZ,iBAAiB;MACjB,mBAAmB;MACnB,gBAAgB,EAAA;IA3NtB;MA+NM,YAAY,EAAA;IA/NlB;MAmOM,oBAAoB,EAAA;IAnO1B;MAuOM,cAAc;MACd,WAAW,EAAA;IAxOjB;MA4OM,gBAAgB;MAChB,cDvO0B;MCwO1B,qBAAqB,EAAA;IA9O3B;MAkPM,sBAAsB;MACtB,0BAA0B,EAAA;IAnPhC;MAuPM,eAAe;MACf,cDlP0B;MCmP1B,qBAAqB,EAAA;IAzP3B;MA6PM,iBAAiB,EAAA;IA7PvB;MAiQM,WAAW;MACX,oBAAoB;MACpB,oBAAoB;MACpB,uBAAuB,EAAA;IApQ7B;MAwQM,YAAY,EAAA;IAxQlB;MA4QM,yBDnQwB,EAAA;ICT9B;MAgRM,yBD5QkC,EAAA;ICJxC;MAoRM,yBD1R0B;MC2R1B,kBAAkB;MAClB,6BAA6B;MAC7B,aAAa;MACb,gBAAgB;MAChB,iBAAiB;MACjB,YAAY;MACZ,yBAAyB,EAAA;IA3R/B;MA+RM,YAAY;MACZ,WAAW;MAEX,6BAA6B;MAC7B,qBAAc;MAAd,cAAc,EAAA;IAnSpB;MAuSM,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB,EAAA;MAzSxB;QA4SQ,sBAAsB;QACtB,aAAa;QACb,iBAAiB,EAAA;;AAMzB;EACE;IAGM,eAAe,EAAA,EAChB","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import \"../../../theme/_variables.scss\";\n\n$paddingLeftSize: 30px;\n$paddingTopSize: 10px;\n$tableDividerLineColor: #222224;\n$tableDividerLineBorderSize: 0.5px;\n$tableFontSize: 1.2vw;\n$positionTop: 140px;\n\n.StormWaterTrueQIForecast {\n  color: $primaryFontColor;\n  background-color: $containerScreenBackgroundColor;\n  height: 90vh;\n  width: 100%;\n  margin: 0px;\n  padding: 0px;\n\n  padding-left: $paddingLeftSize;\n  padding-right: $paddingLeftSize;\n  padding-top: $paddingTopSize;\n\n  .expand-container {\n    position: absolute;\n    top: 65px;\n    left: 70px;\n    height: 90vh !important;\n    width: 91%;\n    z-index: 100;\n  }\n\n  .mapboxgl-popup-content {\n    min-width: 405px;\n    padding: 0px !important;\n    ;\n    opacity: .95;\n    border-radius: 4px;\n    width: 100% !important;\n    background-color: #18244c;\n  }\n\n  .mapboxgl-popup-anchor-top .mapboxgl-popup-tip {\n    border-bottom-color: #18244c;\n    opacity: .8;\n  }\n\n  .mapboxgl-popup-close-button {\n    display: none;\n  }\n\n  .popup-container {\n    padding-top: 7px;\n    padding-bottom: 32px;\n    padding-left: 10px;\n    padding-right: 4px;\n    font-size: 14px;\n    min-width: 405px;\n    background-color: #050E25;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    width: max-content;\n    font-weight: 500;\n    opacity: .95;\n    text-align: center;\n    height: 115px;\n    line-height: 10px;\n    font-family: \"Urbanist\";\n    display: flex;\n    flex-direction: column;\n    width: max-content;\n  }\n\n  .popup-content {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n  }\n\n\n  .popup-content-left {\n    text-align: right;\n    margin-right: 10px;\n    min-width: 80px;\n    max-width: min-content;\n    line-height: 14px;\n    word-wrap: break-word;\n  }\n\n  .popup-content-left p {\n    text-align: right;\n    word-wrap: break-word;\n  }\n\n\n  .popup-content-right {\n    text-align: left;\n    max-width: 250px;\n    line-height: 14px;\n    font-size: 18px;\n  }\n\n  .popup-content-right-double {\n    height: 28px;\n  }\n\n  .popup-content-highlight {\n    color: #49b4cd;\n  }\n\n  .container {\n    display: flex;\n    padding: 0;\n    height: 90%;\n    margin-top: 10px;\n    max-width: inherit;\n\n    input,\n    select {\n      margin-bottom: 50px;\n    }\n\n    .map-title {\n      width: auto;\n      white-space: nowrap;\n      position: absolute;\n      left: 59px;\n      top: 0px;\n      font-size: 1.25rem;\n      padding: 5px;\n      z-index: 9;\n    }\n\n    .map-best-container {\n      background-color: $topMenuBackgroundColor;\n      border-radius: 2px;\n      box-shadow: 0px 0px 20px #000;\n      display: flex;\n      position: relative;\n      height: 50vh;\n      padding: 0px !important;\n    }\n\n    .map-legend {\n      width: 259px;\n      position: absolute;\n      border-radius: 5px;\n      padding: 5px;\n      right: 40px;\n      bottom: 10px;\n      background-color: #18244c;\n      z-index: 90;\n      height: 170px;\n    }\n\n    .map-legend p {\n      margin-left: 5px;\n      margin-bottom: 24px;\n      height: 35px;\n    }\n\n    .map-legend span {\n      width: 100px;\n      margin-left: 5px;\n    }\n\n    .map-legend-dot {\n      background-color: #4b5ea6;\n      height: 14px;\n      width: 14px;\n      margin-left: 5px;\n      margin-right: 5px;\n      border-radius: 50%;\n      display: inline-flex;\n    }\n\n    .attribution-textbox {\n      font-size: .6rem;\n      position: absolute;\n      right: 1px;\n      bottom: 0px;\n      width: auto;\n    }\n\n    .expand-container-summary {\n      position: absolute;\n      top: 59px;\n      left: 50px;\n      height: 90vh !important;\n      width: 95% !important;\n      z-index: 100;\n      padding-top: 45px !important;\n      overflow: scroll !important;\n      flex-flow: wrap;\n    }\n\n    .expand-summary-button {\n      display: unset;\n      position: absolute;\n      top: 1px;\n      left: 0px;\n      z-index: 1001;\n    }\n\n    .summary-container {\n      background-color: $topMenuBackgroundColor;\n      border-radius: 2px;\n      box-shadow: 0px 0px 20px #000;\n      display: flex;\n      margin-top: 12px;\n      margin-left: 10px;\n      padding-top: 0px;\n      height: 33vh;\n      width: 300px;\n      overflow-x: hidden;\n      overflow-y: scroll;\n      flex-direction: column;\n    }\n\n    .summary-header {\n      flex-wrap: nowrap;\n      width: 220px;\n    }\n\n    .card {\n      padding-left: 2px;\n      width: 250px;\n      line-height: 18px;\n      margin-bottom: 10px;\n      max-width: 250px;\n    }\n\n    .card-header {\n      height: 37px;\n    }\n\n    .card-title p {\n      margin-bottom: .1rem;\n    }\n\n    .card-title hr {\n      margin: 0.1rem;\n      opacity: .1;\n    }\n\n    .summary-card-label {\n      font-size: .8rem;\n      color: $secondarySubtitleColor;\n      padding-bottom: .1rem;\n    }\n\n    .summary-card-label-hr {\n      opacity: .5 !important;\n      padding: 0.1rem !important;\n    }\n\n    .summary-card-span-label {\n      font-size: 1rem;\n      color: $secondarySubtitleColor;\n      padding-bottom: .1rem;\n    }\n\n    .summary-container-span {\n      font-size: 1.2rem;\n    }\n\n    .summary-button {\n      width: 44px;\n      display: inline-flex;\n      align-self: flex-end;\n      background-color: white;\n    }\n\n    .summary-top {\n      width: 100px;\n    }\n\n    .te-primary {\n      background-color: $inputBackgroundColor;\n    }\n\n    .te-secondary {\n      background-color: $containerScreenBackgroundColor;\n    }\n\n    .chart-container {\n      background-color: $topMenuBackgroundColor;\n      border-radius: 2px;\n      box-shadow: 0px 0px 20px #000;\n      display: flex;\n      margin-top: 10px;\n      margin-left: 12px;\n      height: 33vh;\n      width: calc(100% - 332px);\n    }\n\n    .chart-line-container {\n      height: 100%;\n      width: 100%;\n      width: -moz-available;\n      width: -webkit-fill-available;\n      width: stretch;\n    }\n\n    .report-options {\n      margin-top: 20px;\n      text-align: right;\n      margin-right: 10px;\n\n      button {\n        background-color: #fff;\n        border: unset;\n        margin-left: 10px;\n      }\n    }\n  }\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {\n  .StormWaterTrueQIForecast {\n    .header-container {\n      h2 {\n        font-size: 20px;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
